(function (window, document) {
  'use strict';

  var readyPromise;
  var loads = {};
  var timeout = 15000;

  function waitFor(check, message) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      function poll() {
        if (check()) return resolve();
        if (Date.now() - started >= timeout) return reject(new Error(message));
        setTimeout(poll, 50);
      }
      poll();
    });
  }

  // Only a confirmed network error permits another script execution. A slow
  // request may still execute later, so a timeout must not start a duplicate.
  function loadScript(url) {
    if (loads[url]) return loads[url];
    loads[url] = new Promise(function (resolve, reject) {
      function attempt(number) {
        var script = document.createElement('script');
        var timer = setTimeout(function () {
          reject(new Error('Timed out loading ' + url));
        }, timeout);
        script.async = true;
        script.src = url;
        script.onload = function () {
          clearTimeout(timer);
          resolve();
        };
        script.onerror = function () {
          clearTimeout(timer);
          script.remove();
          if (number < 3) {
            setTimeout(function () { attempt(number + 1); }, number * 500);
          } else {
            reject(new Error('Failed to load ' + url + ' after 3 attempts'));
          }
        };
        document.head.appendChild(script);
      }
      attempt(1);
    });
    return loads[url];
  }

  function ensureReady() {
    if (readyPromise) return readyPromise;
    readyPromise = waitFor(function () {
      return window.geckoShopify && window.jQuery_T4NT &&
        window.nt_settings && typeof window.$script === 'function';
    }, 'Cart theme dependencies are not ready').then(function () {
      var config = document.getElementById('js_ntt4');
      var catUrl = config && config.getAttribute('data-cat');
      var swatchUrl = config && config.getAttribute('data-sw');
      if (!catUrl || !swatchUrl) throw new Error('Missing cart script URLs');

      return loadScript(catUrl).then(function () {
        if (typeof window.geckoShopify.recalculateSwatches !== 'function') {
          throw new Error('Category script did not initialize');
        }
        if (typeof window.geckoShopify.ajaxAddItem !== 'function' &&
            typeof window.geckoShopify.onCartUpdate !== 'function') {
          return loadScript(swatchUrl);
        }
        if (typeof window.geckoShopify.onCartUpdate !== 'function') {
          throw new Error('Swatch script is only partially initialized');
        }
      });
    }).then(function () {
      if (typeof window.geckoShopify.onCartUpdate !== 'function') {
        throw new Error('Swatch loaded without onCartUpdate');
      }
      // Keep the existing theme dependency chain, but never signal network failure as success.
      window.$script.done('sw_loaded');
    });
    return readyPromise;
  }

  window.geckoCart = {
    ready: ensureReady,
    interactive: function () {
      return ensureReady().then(function () {
        return waitFor(function () {
          return window.geckoShopify.cartHandlersReady === true;
        }, 'Cart button handlers are not ready');
      });
    },
    refresh: function () {
      var args = arguments;
      return ensureReady().then(function () {
        return window.geckoShopify.onCartUpdate.apply(window.geckoShopify, args);
      });
    }
  };

  document.addEventListener('cart:refresh', function () {
    window.geckoCart.refresh(0, 1).catch(function (error) {
      console.error('[cart]', error);
    });
  });
})(window, document);
